import env from '@framework/env/env';

export const domain = {
  dealvdrDomain: env('DEALVDR_DOMAIN'),
  loansendDomain: env('LOANSEND_DOMAIN'),
  seventeeng5Domain: env('SEVENTEENG5_DOMAIN'),
  investorsetDomain: env('INVESTORSET_DOMAIN'),
  verisendDomain: env('VERISEND_DOMAIN'),
  researchroomDomain: env('RESEARCHROOM_DOMAIN'),
  scheme: env('DOMAIN_SCHEME'),
  protocol: `${ env('DOMAIN_SCHEME') }:`,
  finsightDomain: env('FINSIGHT_DOMAIN'),
  apiDomain: env('API_DOMAIN'),
  usersDomain: env('USERS_DOMAIN'),
  dealroadshowDomain: env('DEALROADSHOW_DOMAIN'),
  managerDomain: env('MANAGER_DOMAIN'),
  condorDomain: env('CONDOR_DOMAIN'),
  openmarketDomain: env('OPENMARKET_DOMAIN'),
  assetsDomain: env('ASSETS_DOMAIN'),
  allocateDomain: env('ALLOCATE_DOMAIN'),
  evercallDomain: env('EVERCALL_DOMAIN'),
  corsDomains: env('CORS_DOMAINS'),
  creditflowresearchDomain: env('CREDITFLOWRESEARCH_DOMAIN'),
};

export default domain;
